/**
 * Input Schema of CargaOpenlog
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {CargaOpenlog} from '@/model/resource/CargaOpenlog'
import {CargaCollection} from '@/model/collection/CargaCollection'

/* TODO: review generated schema */
export class InputCargaOpenlogSchema extends Schema {
  collectionCarga = new CargaCollection().noPagination()

  readonly name = 'InputCargaOpenlog'

  readonly fieldSet: FieldSet<CargaOpenlog> = {
    carga: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionCarga.all(),
      },
    }),
    idPedido: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 127,
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
